import React, { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Box, Typography, Button, Chip } from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import { customTextColor, shortDateTime } from "../../utils/const";
import ViewHotlistDrawer from "./ViewHotlistDrawer";

// Dummy data
const dummyHotlistData = [
  {
    hotlistid: 1,
    status: "published",
    hotlist_name: "Tech Talent 2025",
    created_date: "2025-04-15T10:30:00Z",
    candidate_count: 25,
  },
  {
    hotlistid: 2,
    status: "published",
    hotlist_name: "Data Science Experts",
    created_date: "2025-04-10T14:20:00Z",
    candidate_count: 15,
  },
  {
    hotlistid: 3,
    status: "shared",
    hotlist_name: "Cloud Architects",
    created_date: "2025-04-05T09:15:00Z",
    candidate_count: 10,
  },
];

const HotListDrawer = ({ show, handleClose, hotlist }) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedHotlist, setSelectedHotlist] = useState(null);
  const handleOpenDrawer = (hotlist) => {
    setSelectedHotlist(hotlist);
    setShowDrawer(true);
  };

  const handleCloseDrawer = () => {
    setShowDrawer(false);
    setSelectedHotlist(null);
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={true}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "65px",
        width: "55%",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
      }}
    >
      <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
        <Box sx={{ padding: "10px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0px 10px",
              mb: "10px",
            }}
          >
            <Typography variant="h6" style={{ color: customTextColor }}>
              Hotlist Overview -{" "}
              {hotlist?.bench_sell_recruiter?.profiles[0]?.fullName} |{" "}
              {shortDateTime(hotlist?.hotlists[0]?.updated_at) || "N/A"}
            </Typography>
            <RxCross2
              style={{
                fontSize: "15px",
                cursor: "pointer",
                color: customTextColor,
              }}
              onClick={handleClose}
            />
          </Box>
          <Box sx={{ padding: "0px 10px" }}>
            {/* Hotlist Items */}
            <Box>
              {hotlist?.hotlists?.length > 0 ? (
                hotlist?.hotlists?.map((hotlist) => (
                  <Box
                    key={hotlist.hotlistid}
                    sx={{
                      padding: "10px",
                      border: "1px solid #e0e0e0",
                      mb: "10px",
                      borderRadius: "3px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <Typography
                        variant="body1"
                        display="flex"
                        alignItems="center"
                      >
                        <b>{hotlist?.name || "N/A"}</b>{" "}
                        <Chip
                          label={hotlist?.status}
                          size="small"
                          sx={{
                            backgroundColor:
                              hotlist.status === "Published"
                                ? "#d4edda"
                                : "#d1ecf1",
                            color:
                              hotlist.status === "Published"
                                ? "#155724"
                                : "#0c5460",
                            fontSize: "6px",
                            height: "15px",
                            borderRadius: "3px",
                            padding: "0px",
                            ml: 0.5,
                            fontWeight: 500,
                            textTransform: "capitalize",
                          }}
                        />
                      </Typography>

                      <Typography variant="body2">
                        {hotlist?.candidate_count || "0"} Consultant Available
                      </Typography>

                      <Typography variant="body2">
                        {shortDateTime(hotlist.updated_at) || "N/A"}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        gap: 1,
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={() => handleOpenDrawer(hotlist)}
                        sx={{
                          backgroundColor: "#00b0f0",
                          textTransform: "capitalize",
                          borderRadius: "3px",
                          mt: "15px",
                          padding: "5px 10px",
                          boxShadow: "none",
                          "&:hover": {
                            backgroundColor: "#0085b4",
                            boxShadow: "none",
                          },
                        }}
                      >
                        View Hotlist
                      </Button>
                    </Box>
                  </Box>
                ))
              ) : (
                <Typography variant="body2" style={{ color: customTextColor }}>
                  No hotlists available.
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
        {showDrawer && (
          <ViewHotlistDrawer
            show={showDrawer}
            handleClose={handleCloseDrawer}
            hotlist={selectedHotlist}
            hotProfile = {hotlist?.bench_sell_recruiter?.profiles[0]}
          />
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default HotListDrawer;
